module.exports = __webpack_public_path__ + "img/dots.63323f4a.svg";